"use client";

import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export function ReturnToBlog() {
  return (
    <div className="mt-12 pt-6 border-t">
      <Link 
        href="/blog"
        className="inline-flex min-h-[44px] sm:min-h-0 items-center text-primary hover:text-primary/80 transition-colors no-underline"
        aria-label="Return to all blog posts"
      >
        <ArrowLeft className="h-4 w-4 mr-2" aria-hidden="true" />
        Return to Blog
      </Link>
    </div>
  );
}
